import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { CCAuthService } from '@heidelberg/control-center-frontend-integration/auth';
import { catchError, Observable, of } from 'rxjs';
import { BACKEND_URL, ORGANIZATION_REQUEST_PREFIX } from '@data-terminal/data-access/injection-tokens';
import {
    FarewellScreenRequestItem,
    SessionSummaryEntity,
} from '@data-terminal/shared-models/session-summary.interface';

@Injectable({
    providedIn: 'root',
})
export class FarewellApiService {
    private readonly http = inject(HttpClient);
    private readonly backendUrl = inject(BACKEND_URL);
    private readonly orgRequestPrefix = inject(ORGANIZATION_REQUEST_PREFIX);
    private readonly ccAuthService = inject(CCAuthService);

    private readonly FAREWELL_SCREEN_REQUEST_URL: (userId: string) => string = (userId: string) =>
        `${this.backendUrl}${this.orgRequestPrefix}farewellscreen/${userId}`;

    public getFarewellScreenData(body: FarewellScreenRequestItem[]): Observable<SessionSummaryEntity[]> {
        const email = this.ccAuthService.getCurrentUser()?.email;
        if (email) {
            return this.http
                .post<SessionSummaryEntity[]>(this.FAREWELL_SCREEN_REQUEST_URL(email), body)
                .pipe(catchError(() => []));
        }
        return of([]);
    }
}
